import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 border-b-2 border-gray-200 pb-4">
            Terms and Conditions
          </h1>

          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>
          
          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            <p>
              These Terms and Conditions govern the use of <span className="font-bold">www.rtextiles.in</span> (“Website”), owned and operated by <span className="font-bold">Prime Store</span>. By accessing or using this Website, you agree to comply with and be bound by these Terms and Conditions.
            </p>

            <p>
              All products, descriptions, and information displayed on the Website constitute an <span className="font-bold">invitation to offer</span>. When you place an order, it shall be treated as your <span className="font-bold">offer to purchase</span> the selected product(s). An order shall be deemed <span className="font-bold">accepted only upon dispatch</span> of the product(s) and <span className="font-bold">not at the time of order confirmation</span>.
            </p>

            <p>
              Customers will receive notifications regarding <span className="font-bold">order receipt and dispatch</span> via registered email address and/or mobile number.
            </p>

            <p>
              You agree to provide <span className="font-bold">accurate, current, and complete information</span> while registering or placing an order. You are solely responsible for maintaining the confidentiality of your account credentials. Any activity carried out through your account shall be deemed to have been performed by you.
            </p>

            <p>
              The Company reserves the right to <span className="font-bold">suspend or terminate user accounts</span> if any information provided is found to be false, misleading, or incomplete.
            </p>

            <p>
              Prices displayed on the Website may occasionally contain errors. In such cases, the Company reserves the right to <span className="font-bold">cancel the order or seek confirmation from the customer</span> at the corrected price. Payments may be collected prior to dispatch. Any eligible refunds shall be processed to the <span className="font-bold">original mode of payment</span> and will be subject to applicable banking timelines.
            </p>

            <p>
              The Company reserves the right to <span className="font-bold">cancel orders</span> due to stock unavailability, pricing discrepancies, payment failures, or fraud prevention measures. Customers may cancel orders <span className="font-bold">only before processing or dispatch</span>. Once an order has been shipped, cancellation will not be permitted.
            </p>

            <p>
              Product images shown on the Website are for <span className="font-bold">illustrative purposes only</span>. Minor color variations of approximately <span className="font-bold">2%–5%</span> may occur due to lighting or screen resolution differences and are considered normal.
            </p>

            <p>
              In the event of an item being <span className="font-bold">out of stock or damaged</span>, customers will be notified within <span className="font-bold">two (2) working days</span>, and an appropriate refund or resolution will be processed.
            </p>

            <p>
              Customers must use only <span className="font-bold">legally owned and authorized payment instruments</span>. The Website does not store any debit card, credit card, or banking details. In the event of fraudulent activity, liability shall lie with the customer unless proven otherwise.
            </p>

            <p>
              Customers are responsible for providing a <span className="font-bold">complete and accurate delivery address</span>. Any additional costs incurred due to incorrect or incomplete address details shall be borne by the customer.
            </p>

            <p>
              The Company reserves the right to <span className="font-bold">modify or update these Terms and Conditions at any time</span> without prior notice. Continued use of the Website after such changes constitutes acceptance of the revised Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;